import { Component } from '@opten/compiler/metadata/component';
import { getCookie } from '@opten/cookie/get';
import { setCookie } from '@opten/cookie/set';
import { addClass } from '@opten/dom/add-class';
import { hasClass } from '@opten/dom/has-class';
import { removeClass } from '@opten/dom/remove-class';
import { toggleClass } from '@opten/dom/toggle-class';

@Component({ className: 'js-modal' })
export class ModalComponent {
	private triggers: HTMLElement[];
	private cookieKey: string;
	private cookieDays: number;

	constructor(private element: HTMLElement) {
		this.cookieKey = `modal-ignore-${element.id}`;
		this.cookieDays =
			parseInt(this.element.getAttribute('data-cookie-ignore')) || -1;

		if (this.cookieDays >= 0 && getCookie(this.cookieKey) !== 'true') {
			addClass(this.element, 'is-open');
		}

		this.triggers = Array.from(
			document.querySelectorAll(
				`[href="#${this.element.id}"], [data-target="#${this.element.id}"]`
			)
		);

		this.triggers.forEach((trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				toggleClass(this.element, 'is-open');
				if (hasClass(this.element, 'is-open') == false) {
					this.closeEvent();
				}
			});
		});

		document.addEventListener('click', (e) => {
			if (
				hasClass(this.element, 'is-open') &&
				(!e.target.closest('.c-modal__inner') ||
					e.target.closest('.js-modal-close'))
			) {
				e.preventDefault();
				removeClass(this.element, 'is-open');
				this.closeEvent();
			}
		});
	}

	private closeEvent() {
		if (this.cookieDays >= 0 && getCookie(this.cookieKey) !== 'true') {
			const date = new Date();
			date.setDate(date.getDate() + 1);
			setCookie(this.cookieKey, 'true', date, '/');
		}
	}
}
